import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { IOptionType } from './helpers/typings';

type OptionCardProps = {
    option: IOptionType;
    onEdit?: () => void;
    onDelete?: () => void;
};

const OptionCard: React.FC<OptionCardProps> = ({
    option,
    onEdit,
    onDelete,
}) => {
    return (
        <Card className="mb-2">
            <Card.Body>
                <Card.Title className="mb-2">
                    Option (Rank: {option.rank})
                </Card.Title>
                <p className="mb-2">
                    <strong>Option Type:</strong> {option.type.category}
                </p>
                <p className="mb-2">
                    <strong>Value:</strong> {option.value}
                </p>
                {option.type.subCategory && (
                    <p className="mb-2">
                        <strong>Subcategory:</strong> {option.type.subCategory}
                    </p>
                )}
                {option.type.selectionType && (
                    <p className="mb-2">
                        <strong>Selection Type:</strong>{' '}
                        {option.type.selectionType}
                    </p>
                )}
                {option.range && (
                    <>
                        <p className="mb-2">
                            <strong>Range:</strong>
                        </p>
                        <ul className="mb-2">
                            {option.range.min && (
                                <li className="mb-1">
                                    Min: Value -{' '}
                                    {option.range.min.value ?? 'N/A'}, Unit -{' '}
                                    {option.range.min.unit}
                                </li>
                            )}
                            {option.range.max && (
                                <li className="mb-1">
                                    Max: Value -{' '}
                                    {option.range.max.value ?? 'N/A'} , Unit -{' '}
                                    {option.range.max.unit}
                                </li>
                            )}
                        </ul>
                    </>
                )}
                <div className="d-flex justify-content-start gap-2">
                    {onEdit && (
                        <Button
                            variant="primary"
                            className="mt-0"
                            onClick={onEdit}
                        >
                            Edit
                        </Button>
                    )}
                    {onDelete && (
                        <Button
                            variant="danger"
                            className="mt-0"
                            onClick={onDelete}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default OptionCard;
